import { Base } from './base-model';
import { Song } from './song';
import { Type, instanceToInstance } from 'class-transformer';

export class Collection extends Base {
    name: string
    description: string
    image: string
    @Type(() => Song)
    songs: Song[]
    sortLabel: string

    static defaults(): Collection {
        const collection = new Collection()
        collection.name = ''
        collection.description = ''
        collection.image = null
        collection.songs = []
        return collection
    }

    findSong(uuid: string): Song {
        return this.songs?.find((song: Song) => uuid && (song.uuid === uuid) ) ?? null
    }

    indexOfSong(uuid: string): number {
        return this.songs?.findIndex((song: Song) => uuid && (song.uuid === uuid) ) ?? -1
    }

    // TODO: Implement the following as a mixin. THere are other models that use tagList(), tagsMatchAny, and xxxxWithTags(),
    // although they may need to override the default implementation

    tagsList(): string[] {
        const tags = new Set<string>()
        if (this.songs) {
            this.songs.forEach( (song: Song) => {
                song.tagsList().forEach( (tag: string) => tags.add(tag.toLowerCase()))
            })
            return Array.from(tags.values()).sort()            
        }
        return []
    }

    tagsMatchAny(tags: string[]): boolean {
        return this.tagsList().some ( (collectionTag: string) => {
            return tags.some( (tag: string) => tag.toLowerCase() === collectionTag.toLowerCase() )
        })
    }

    get isWelcome(): boolean {
        return this.name.startsWith('Welcome')
    }

    static collectionsWithTags(collections: Collection[], tags: string[]): Collection[] {
        const results: Collection[] = []
        collections.forEach( (collection: Collection) => {
          if (collection.tagsMatchAny(tags)) {
            results.push(collection)
          }
        })
        return results
    }

    static sort(collections: Collection[], welcomeAtTop: boolean = true) {
        return instanceToInstance(collections).sort((a: Collection, b: Collection) => {
            if (welcomeAtTop) {
                if (a.isWelcome) { return -1 }
                if (b.isWelcome) { return 1 }
            }

            if (a.sortLabel === b.sortLabel) {
                return a.name < b.name ? -1 : 1
            }

            for (const sortLabel of ['Core collection', 'Spanish', 'Italian', 'Rhythm Kids', 'In-School', 'Play Along', 'Big Kids']) {
                if (a.sortLabel.toLowerCase() === sortLabel.toLowerCase()) { return -1 }
                if (b.sortLabel.toLowerCase() === sortLabel.toLowerCase()) { return 1 }
            }

            return a.name < b.name ? -1 : 1
        })
    }

}
